import { useState } from 'react';

export const useImportForm = () => {
  const [initialImportForm, setInitialImportForm] = useState({
    numberOfPatients: '0',
    generalNote: '',
    selectedType: null
  });

  const handleImportTypeSelection = (type) =>
    setInitialImportForm((prev) => ({ ...prev, selectedType: type }));

  const handleChange = (field, value) => {
    setInitialImportForm((prev) => ({ ...prev, [field]: value }));
  };

  return {
    initialImportForm,
    setInitialImportForm,
    handleChange,
    handleImportTypeSelection
  };
};

export const useImportModals = () => {
  const [showPastImports, setShowPastImports] = useState(false);
  const [showImportOverview, setShowImportOverview] = useState({
    isOpen: false,
    data: null,
    file: null
  });
  const [showImportCSV, setShowImportCSV] = useState(false);
  const [showProcessingFiles, setShowProcessingFiles] = useState(false);
  const [showSoftwareExport, setShowSoftwareExport] = useState(false);

  return {
    showPastImports,
    setShowPastImports,
    showImportOverview,
    setShowImportOverview,
    showImportCSV,
    setShowImportCSV,
    showProcessingFiles,
    setShowProcessingFiles,
    showSoftwareExport,
    setShowSoftwareExport
  };
};
